import { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Route } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import pathsData from "@/data/publicPaths.json";

export default function PublicPaths() {
  useEffect(() => {
    document.title = "Free AI Learning Paths — AI Pathshaalaa";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background" data-testid="public-paths-page">
      <Navbar />
      <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-28 pb-24">
        <p className="font-mono text-xs font-bold uppercase tracking-widest text-primary inline-flex items-center gap-1.5">
          <Route className="h-4 w-4" /> Learning paths
        </p>
        <h1 className="mt-2 font-heading font-extrabold tracking-tight text-4xl sm:text-5xl">
          Pick a path. <span className="gradient-text">Or let the quiz pick for you.</span>
        </h1>
        <p className="mt-3 text-base md:text-lg text-muted-foreground max-w-2xl">
          Structured AI courses built from the best free YouTube lessons — for every level, profession and goal.
        </p>

        <div className="mt-10 grid sm:grid-cols-2 gap-4">
          {pathsData.paths.map((p, i) => (
            <motion.div key={p.slug} initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: Math.min(i * 0.06, 0.4) }}>
              <Link to={`/paths/${p.slug}`} data-testid={`path-card-${p.slug}`}
                className="group flex flex-col h-full rounded-2xl border border-border bg-card p-6 shadow-brutal brutal-lift">
                <h2 className="font-heading font-bold text-xl group-hover:text-primary transition-colors">{p.title}</h2>
                <p className="mt-2 text-sm text-muted-foreground flex-1">{p.tagline}</p>
                <div className="mt-4 flex items-center justify-between">
                  <span className="text-xs font-medium text-muted-foreground">{p.modules.length} modules · {p.level}</span>
                  <ArrowRight className="h-4 w-4 text-primary group-hover:translate-x-1 transition-transform" />
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
